import React from 'react';
import spinner from './spinner.gif';

export default () => {
  return (
    <div className="w-100">
      <img
        src={spinner}
        style={{
          width: '180px',
          margin: 'auto',
          padding: '50px',
          display: 'block'
        }}
        alt="Loading..."
      />
    </div>
  );
};
